import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AssistantService {
  constructor(private http: HttpClient) {}

  stringToObject(string) {
    return JSON.parse(string.replace(/'/g, '"'));
  }

  isStringifyedObj(string) {
    if (typeof string !== "string") {
      return false;
    }
    try {
      const parsed = this.stringToObject(string);
      return typeof parsed === "object" && parsed !== null;
    } catch (e) {
      return false;
    }
  }

  aiContextFormatter(aiContexts) {
    aiContexts.forEach((aiContext) => {
      for (let field in aiContext) {
        if (Array.isArray(aiContext[field])) {
          aiContext[field] = aiContext[field].map((stringifyedObj) =>
            this.stringToObject(stringifyedObj),
          );
        }
        if (
          typeof aiContext[field] === "string" &&
          aiContext[field] !== "None" &&
          this.isStringifyedObj(aiContext[field])
        ) {
          aiContext[field] = this.stringToObject(aiContext[field]);
        }
        if (aiContext[field] === "None") aiContext[field] = null;
      }
    });
    return aiContexts;
  }

  sendQuery(
    query: string,
    magicConversationUuid,
    clientCompanyUuid,
  ): Promise<any> {
    const url = `${environment.aiBackendUrl}/ai/${clientCompanyUuid}`;
    return this.http
      .post(url, { query, magic_conversation_uuid: magicConversationUuid })
      .toPromise();
  }

  updatePineconeMessage(message: any, is_delete = false): Promise<any> {
    const url = `${environment.apiUrl}/ai-assistant/messages`;
    return this.http.post(url, { message, is_delete }).toPromise();
  }

  getTrackedItemDetails(uuid: string): Promise<any> {
    const url = `${environment.apiUrl}/ai-assistant/tracked-item?item=${uuid}`;
    return this.http.get(url).toPromise();
  }

  indexData(): Promise<any> {
    const url = `${environment.apiUrl}/ai-assistant/index-data`;
    return this.http.post(url, {}, { observe: "response" }).toPromise();
  }

  getMagicConversations(): Promise<any> {
    const url = `${environment.apiUrl}/ai-assistant`;
    return this.http.get(url, {}).toPromise();
  }

  getClientMagicConversations(clientCompanyUuid): Promise<any> {
    const url = `${environment.apiUrl}/ai-assistant/${clientCompanyUuid}`;
    return this.http.get(url, {}).toPromise();
  }

  deleteMagicConversation(conversationUuid: string): Promise<any> {
    const url = `${environment.apiUrl}/ai-assistant?id=${conversationUuid}`;
    return this.http.delete(url).toPromise();
  }

  renameMagicConversation(newTitle, uuid): Promise<any> {
    const url = `${environment.apiUrl}/ai-assistant`;
    return this.http
      .put(url, { new_title: newTitle, magic_conversation_uuid: uuid })
      .toPromise();
  }
}
